"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutZOrder = void 0;
/**
 * Take care when changing this -- if you increase the max value, it impacts
 * SceneManager.getCameraZPosition() which impacts schematic camera position
 * and can result in metamodules/labels disappearing, among other possible
 * side effects.
 *
 * @todo we should make that behaviour more robust!
 */
exports.LayoutZOrder = {
    grid: -1,
    default: 1,
    measureTool: 1,
    branch_point: 3,
    element: 2,
    element_label: 3,
    terminal: 3,
    terminal_hovered: 3,
    terminal_label: 4,
    dragging_subject: 5,
    route: 6,
    route_hovered: 7,
    route_selected: 7,
    presence: 8,
    commentThreadPin: 7,
    commentThread: 9,
    dragging_comment_thread_pin: 9,
    focused_comment_thread_pin: 9,
    alignment_guide: 9,
    left_right_drawers: 10,
    bottom_navigation: 10,
    controls: 10,
    layer_menu: 10,
    layer_controls: 11,
};
//# sourceMappingURL=layout.js.map